import Home from '@/pages/Home';

// Pages as own Component
import Privacy from '@/pages/Privacy';
import BecomeMember from '@/pages/BecomeMember';
import Scopes from '@/pages/Scopes';
import News from '@/pages/News';

export const routes = [
  {
    path: '/',
    component: Home,
    name: 'home',
    props: true
  },
  {
    path: '/news',
    component: News,
    name: 'news'
  },
  {
    path: '/privacy',
    component: Privacy,
    name: 'privacy'
  },
  {
    path: '/arbeitsgruppen',
    component: Scopes,
    name: 'arbeitsgruppen'
  },
  {
    path: '/become_member',
    component: BecomeMember,
    name: 'become_member'
  },


  {
    path: '*',
    redirect: '/'
  },
];
